import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UberweiserOpenDialogComponent} from './uberweiser-open-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule
    ],
    declarations: [UberweiserOpenDialogComponent],
    exports: [UberweiserOpenDialogComponent]
})
export class UberweiserOpenDialogModule {
}
